<div class="modal-header d-block">
  <figure class="text-center modal-header-logo" *ngIf="logoUrl">
    <img [src]="logoUrl" class="logo" alt="Logo" *ngIf="logoUrl">
  </figure>
  <h4 *ngIf="!termsChangedError" class="modal-title pull-center">
    Do you want to confirm this offer?
  </h4>
  <h4 *ngIf="termsChangedError" class="modal-title pull-center">
    {{termsChangedErrorMsg}}
  </h4>
  <button type="button" *ngIf="!termsChangedError" class="close pull-right" aria-label="Close"
    (click)="modalRef1.hide()" [disabled]="loading">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" [class.importantLimitNoteActive]="offerMaxLimit !== undefined && offerMaxLimit >= 150000">
  <div *ngIf="!termsChangedError" class="offerDetailsWrapper">

    <div class="detailRow1">
      <div class="detailItem" *ngIf="offerMaxLimit">
        <h3 class="title">
          {{ optionIndex === 3 ? 'Offer Amount' : (isLoanProductMode ? 'Available Limit' : 'Available Spending Limit')
          }}
        </h3>
        <p class="value">
          <!-- $20,000.00 -->
          {{offerMaxLimit | currency}}
        </p>
      </div>
      <div class="detailItem" *ngIf="shouldShowEstAPR()">
        <h3 class="title">
          {{ isLoanProductMode ? 'Repayment per $1' : 'Estimated APR' }}
        </h3>
        <p class="value">
          {{estAPR}}
        </p>
      </div>
      <div class="detailItem">
        <h3 class="title">
          {{ (isLoanProductMode || shouldShowEstAPR()) ? 'Repayment per $1' : 'Factor Rate' }}
        </h3>
        <p class="value">
          {{ (isLoanProductMode || shouldShowEstAPR()) ? '$' : '' }}{{ offerFactor | number:'1.2-2' }}
        </p>
      </div>
      <div class="detailItem">
        <h3 class="title">
          {{ optionIndex === 3 ? "Payback Period" : (isLoanProductMode ? "Repayment Period" : "Estimated Payback
          Period")}}
        </h3>
        <p class="value">
          {{offerTerm}}
        </p>
      </div>
      <div class="detailItem">
        <h3 class="title">
          {{ optionIndex === 3 ? (selectedOption | titlecase) + ' Payment' : (isLoanProductMode ? (selectedOption |
          titlecase) + ' Payment' : 'Estimated ' + (selectedOption | titlecase) + ' Payment') }}
        </h3>
        <p class="value" *ngIf="selectedOption === 'daily'">
          {{offerDailyPayment | currency}}
        </p>
        <p class="value" *ngIf="selectedOption === 'weekly'">
          {{(offerDailyPayment * 5) | currency}}
        </p>
      </div>
    </div>

    <div class="detailRow2">
      <div class="detailItem2">
        <h3 class="title">
          Payment Frequency
        </h3>
        <p class="value">
          {{collectionSchedule | titlecase}}
        </p>
      </div>
    </div>

    <!-- *ngIf="offerMaxLimit !== undefined && offerMaxLimit >= 150000" -->
    <p class="importantLimitNote" *ngIf="offerMaxLimit !== undefined && offerMaxLimit >= 150000">
      <mat-icon>info</mat-icon>
      Accepting this offer may require additional financials
    </p>

    <div class="detailRow3">
      <div class="email-card" *ngIf="true">
        <div *ngIf="!isEditing; else editTemplate">
          <p class="label">
            {{ optionIndex === 3
            ? "Please provide the merchant's email address where the contract will be received:"
            : "Please provide the merchant's email address where the contract will be received:"}}
          </p>
          <div class="email-display mt-3">
            <span class="value">{{ merchantEmail }}
              <span *ngIf="emailValidationWarning" class="email-warning-error">
                {{ emailValidationWarning }}
              </span>
            </span>
            <button mat-icon-button color="primary" (click)="isEditing = true; emailValidationWarning = ''" [disabled]="loading">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>

        <ng-template #editTemplate>
          <p class="label">
            {{ optionIndex === 3
            ? "Please enter the merchant's correct email address to accept this offer. An accurate email will help to
            ensure a more seamless and timely contract generation process for the merchant."
            : "Please provide the merchant's email address where the contract will be received:"}}
          </p>
          <div class="infoRow email-input mt-3">
            <mat-form-field appearance="outline" class="myMatFormFieldCustom w-100 mb-0"
              [ngClass]="{'email-input-invalid': emailRef.invalid && emailRef.touched}" subscriptSizing="dynamic">
              <input matInput [(ngModel)]="tempEmail" #emailRef="ngModel" required type="email"
                placeholder="Please enter Email Address" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                email (input)="onEmailInputChange()" />
              <mat-error *ngIf="emailRef.invalid && emailRef.touched">
                <span *ngIf="emailRef.errors?.['required']">Email is required.</span>
                <span *ngIf="emailRef.errors?.['email'] && !emailRef.errors?.['required']">Please enter a valid email
                  address.</span>
                <span
                  *ngIf="emailRef.errors?.['pattern'] && !emailRef.errors?.['required'] && !emailRef.errors?.['email']">Please
                  enter a valid email format.</span>
              </mat-error>
              <span *ngIf="emailValidationWarning" class="email-warning-error">
                {{ emailValidationWarning }}
              </span>
            </mat-form-field>
            <div class="action-icons" [ngClass]="{'mb-3': emailRef.invalid && emailRef.touched}">
              <button mat-icon-button color="primary" (click)="saveEmail()" [disabled]="emailRef.invalid"
                [ngClass]="{'button-disabled': emailRef.invalid}">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEdit()" [disabled]="emailRef.invalid"
                [ngClass]="{'button-disabled': emailRef.invalid}" *ngIf="merchantEmail">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="infoRow">
            <p class="successmessage mt-2">
              <em>Your email has been updated. Please review the offer details and click "Accept Offer" to proceed with
                this
                offer.
              </em>
            </p>
          </div>
        </ng-template>
      </div>
      <div class="email-card" *ngIf="false">
        <mat-label class="fw-bold d-block">Please confirm or provide the merchant's email address where the contract
          will be received:</mat-label>
        <!-- <div class="email-display mt-3">
          <span class="value">{{ merchantEmail }}</span>
        </div> -->
        <mat-radio-group [(ngModel)]="confirmEmail" class="merchant-email-radio-group">
          <mat-radio-button value="yes">{{ merchantEmail }}</mat-radio-button>
          <br />
          <mat-radio-button value="no">Use different email</mat-radio-button>
        </mat-radio-group>

        <div *ngIf="confirmEmail === 'no'" class="update-email-input ">
          <!-- <mat-form-field appearance="outline" class="full-width"> -->
          <mat-label class="fw-bold">Enter new email address</mat-label>
          <mat-form-field appearance="outline" class="myMatFormFieldCustom w-100 mt-3 mb-3" subscriptSizing="dynamic">
            <input matInput [(ngModel)]="email" placeholder="Enter email address" />
          </mat-form-field>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="modal-footer">
  <button *ngIf="!termsChangedError" type="button" class="btn btn-default acceptBtn"
    (click)="openStatusModal(confirmStatusTemplate)" [disabled]="loading || !isEmailValid">
    <span *ngIf="!loading">Accept Offer</span>
    <span *ngIf="loading" class="acceptBtnLoadingState">
      Processing...
      <span class="acceptBtnSpinner"></span>
    </span>
  </button>
  <button *ngIf="!termsChangedError" type="button" class="btn btn-default cancelBtn" (click)="modalRef1.hide()"
    [disabled]="loading">Go
    Back</button>
  <button *ngIf="termsChangedError" type="button" class="btn btn-default acceptBtn" (click)="reloadPage()"
    [disabled]="loading">Reload</button>
</div>




<ng-template #confirmStatusTemplate>
  <div class="modal-header">

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef2.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <img src="../../../../../assets/new-dash/logo/revenuedLogo_black.svg" alt="Success" class="icon" />
    <h3 class="title">
      Thank you!
    </h3>
    <p class="message">
      Your offer has been submitted
    </p>
  </div>
  <!-- <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modalRef2.hide()">Close</button>
  </div> -->
</ng-template>